import PropTypes from 'prop-types';
import {Component} from 'react';
import injectSheet from 'react-jss';
import classNames from 'classnames';

import {rem} from '-/styles/utils';

const styles = theme => ({
    checkbox: {
        display: 'block',
        marginBottom: rem(17),
        '&.disabled': {
            opacity: 0.5
        },
        '& input[type="checkbox"]': {
            display: 'none'
        },
        '& input[type="checkbox"] + span': {
            display: 'inline-block',
            position: 'relative',
            top: -1,
            width: 20,
            height: 20,
            verticalAlign: 'middle',
            backgroundColor: 'white',
            border: '1px solid #ccc',
            cursor: 'pointer',
            marginRight: 5
        },
        '& input[type="checkbox"]:checked + span': {
            background: theme.colors.primary
        },
        '& input[type="checkbox"]:checked + span i': {
            color: 'white',
            display: 'block',
            marginLeft: 1
        },
        '& input[type="checkbox"] + span i': {
            display: 'none'
        }
    }
});

class Checkbox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            checked: false
        };
    }

    static propTypes = {
        handleCheckboxChange: PropTypes.func.isRequired
    };

    toggleCheckbox = () => {
        const {handleCheckboxChange, disabled} = this.props;
        const {checked: oldValue} = this.state;
        const checked = !oldValue;

        if (disabled) {
            return;
        }

        this.setState({
            checked
        });

        handleCheckboxChange({checked});
    };

    render() {
        const {classes = {}, disabled, children} = this.props;
        const {checked} = this.state;
        const className = classNames(classes.checkbox, {
            disabled
        });

        return (
            <span onClick={this.toggleCheckbox} className={className}>
                <input
                    type="checkbox"
                    checked={checked}
                    readOnly={true}
                />
                <span><i className="fa fa-check" /></span>
                {children}
            </span>
        );
    }
}

export default injectSheet(styles)(Checkbox);
